import React, { Component } from "react";
import { PostData } from "../../../../service/postData";
import { sendNotification } from "../../../../_notificationSettings/notificationPanel";
import { MDBDataTableV5 } from "mdbreact";
import { numberFormat } from "../../../../config/numberFormat";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import moment from "moment"; 
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { PaginationControl } from 'react-bootstrap-pagination-control';
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import * as FileSaver from 'file-saver';

import DownloadBtnSaleInvoicePdf from '../../Invoices/Sale/DownloadBtnSaleInvoicePdf';
import PrintBtnSaleInvoicePdf from '../../Invoices/Sale/PrintBtnSaleInvoicePdf';
import DownloadBtnSaleReturnInvoicePdf from '../../Invoices/SaleReturn/DownloadBtnSaleReturnInvoicePdf';
import PrintBtnSaleReturnInvoicePdf from '../../Invoices/SaleReturn/PrintBtnSaleReturnInvoicePdf';

let _businessSetting = {};
let _signingId = "0";
let _businessId = "0";
let _companyId = "0";
 

let columns = [
  {
    label: '#',
    field: 'srNo',
    width: 20,
    attributes: {
    'aria-controls': 'DataTable',
    'aria-label': '#',
    },
  },
  {
    label: "Date",
    field: "invoice_date",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Date",
    },
  },
  {
    label: "Invoice No.",
    field: "invoice_no",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Invoice No.",
    },
  },
  {
    label: "Party Name",
    field: "party_name",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Party Name",
    },
  },
  {
    label: "Transaction Type",
    field: "sale_type",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Party Type",
    },
  },
  {
    label: "Payment Type",
    field: "payment_type",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Party Type",
    },
  },
  {
    label: "Amount",
    field: "total_amount",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Amount",
    },
  },
  {
    label: "Balance Due",
    field: "balance",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Balance Due",
    },
  },
  {
      label: 'Status',
      field: 'status',
      width: 150,
      attributes: {
      'aria-controls': 'DataTable',
      'aria-label': 'status',
      },
  },
  {
    label: "Action",
    field: "actionExtra",
    width: 100,
  },
];

let _loader = "glb-ldr-prt active";
let _currentYear = moment().format("YYYY");
let _startDateYaer = "01/01/" + _currentYear;
let _endDateYaer = "12/31/" + _currentYear;
export default class saleReportPanel extends Component {
  constructor(props) {
    super(props);
    
    let _UserSession = localStorage.getItem("vs_UserSession");
    if (_UserSession!=undefined || _UserSession!=null) {
      _UserSession = JSON.parse(_UserSession);
      _signingId = _UserSession.loginId;
      _businessId = _UserSession.tokenKey;
      _businessSetting = _UserSession.businessSetting;
    }

    let _companySession = localStorage.getItem("vs_UserCompanySession");
    if (_companySession!=undefined || _companySession!=null) {
      _companySession = JSON.parse(_companySession);
      _businessId = _companySession.business_id;
      _companyId = _companySession.company_id;
    }
        
    if(_businessSetting.DueDatesPaymentTerms == 1){
      columns = [
        {
            label: '#',
            field: 'srNo',
            width: 20,
            attributes: {
            'aria-controls': 'DataTable',
            'aria-label': '#',
            },
        },
        {
          label: "Date",
          field: "invoice_date",
          width: 150,
          attributes: {
            "aria-controls": "DataTable",
            "aria-label": "Date",
          },
        },
        {
          label: "Invoice No.",
          field: "invoice_no",
          width: 150,
          attributes: {
            "aria-controls": "DataTable",
            "aria-label": "Invoice No.",
          },
        },
        {
          label: "Party Name",
          field: "party_name",
          width: 150,
          attributes: {
            "aria-controls": "DataTable",
            "aria-label": "Party Name",
          },
        },
        {
          label: "Transaction Type",
          field: "sale_type",
          width: 150,
          attributes: {
            "aria-controls": "DataTable",
            "aria-label": "Party Type",
          },
        },
        {
          label: "Payment Type",
          field: "payment_type",
          width: 150,
          attributes: {
            "aria-controls": "DataTable",
            "aria-label": "Party Type",
          },
        },
        {
          label: "Amount",
          field: "total_amount",
          width: 150,
          attributes: {
            "aria-controls": "DataTable",
            "aria-label": "Amount",
          },
        },
        {
          label: "Balance Due",
          field: "balance",
          width: 150,
          attributes: {
            "aria-controls": "DataTable",
            "aria-label": "Balance Due",
          },
        },
        {
            label: 'Status',
            field: 'status',
            width: 150,
            attributes: {
            'aria-controls': 'DataTable',
            'aria-label': 'status',
            },
        },
        {
            label: 'Due Date',
            field: 'due_date',
            width: 150,
            attributes: {
            'aria-controls': 'DataTable',
            'aria-label': 'due dates',
            },
        },
        {
          label: "Action",
          field: "actionExtra",
          width: 100,
        },
      ];
    }
    this.state = {
      buttonTitle: "Add Sale",
      isLoaded: true,
      transactionArray: [],
      transactionArrayFilter: [],
      DueDatesPaymentTerms : _businessSetting.DueDatesPaymentTerms ? _businessSetting.DueDatesPaymentTerms : 0,
      businessId: _businessId,
      company_id: _companyId,
      userId: _signingId,
      name: null,
      paidAmount: 0,
      totalBalanceAmt: 0,
      total: 0,
      startDate : moment().startOf('month').format('YYYY-MM-DD'),
      endDate : moment().endOf('month').format('YYYY-MM-DD'),
      dateLabel: "",
      partyData : [],
      activeTransactionPaymentKey : 'ALL',
      activeTransactionKey : 'ALL',
      activePartyKey : 'ALL',
      overDueAmt : 0,
      pageCount : 10,
      page : 1,
      totalCount  : 0,
      pageShow  : 0,
      setPage : 1,
      searchInvNo : '',
      errors: {
        name: "",
      },
    };
  }

  async componentDidMount() {
    this.getSaleListData(this.state.activeTransactionKey,this.state.activeTransactionPaymentKey,this.state.page,this.state.activePartyKey,this.state.searchInvNo,this.state.pageCount);
    this.getPartyListData(this.state.company_id);
  }

  getPartyListData() {
      let _partyData = [];
      let _url_GetData =
      global.userPartyList + "?company_id=" + this.state.company_id;
      PostData(_url_GetData, "", "GET").then((result) => {
          let responseJson = result;
          if (responseJson.success == false) {
              this.setState({ isLoaded: true });
          } else {
              if (responseJson.response) {
              _partyData = responseJson.response;
              }
              this.setState({ partyData: _partyData, isLoaded: true });
          }
      }).catch((error) => this.setState({ error, isLoaded: false}));
  }

  getInvoiceSearch = (event) => {
      event.preventDefault();
      const { name, value } = event.target;
      let _valueSend = value;
      this.setState({searchInvNo:_valueSend})
      if(_valueSend.length >= 3 || _valueSend == ''){
          this.setState({setPage:1});
          this.getSaleListData(this.state.activeTransactionKey,this.state.activeTransactionPaymentKey,1,this.state.activePartyKey,_valueSend,this.state.pageCount);
      }
  }

  getSaleListData(_type,_paymentStatus,_page,_partyIDS,searchInvSend,pageCount) {

    let _transArray = [];
    let _paidAmt = 0;
    let _unpaidAmt = 0;
    let _totalAmt = 0;
    let _overDueAmt = 0;

    const requestData = JSON.stringify({
      business_id: this.state.businessId,
      company_id: this.state.company_id,
      type:_type,
      payment_status : _paymentStatus,
      partyId : parseFloat(_partyIDS),
      isDateFilter: true,
      start_date: this.state.startDate,
      end_date: this.state.endDate,
      pageCount: pageCount,
      page: _page,
      search_inv_no:searchInvSend,
      withReportTotals: true,
    });

    PostData(global.userSaleTransactionList, requestData, "POST")
      .then((result) => {
        let responseJson = result;
        let totalValueSign = "";
        if (responseJson.success == false) {
          this.setState({
            transactionArrayFilter: _transArray,
            itemArray: _transArray,
            isLoaded: true,
            paidAmount: _paidAmt,
            totalBalanceAmt: _unpaidAmt,
            overDueAmt : _overDueAmt,
            total: _totalAmt,
            totalCount: 0,
            totalValueSign: "",
          });
        } else {
          if (responseJson.response) {
            _transArray = responseJson.response;
          }

          // Use totals from List API response directly
          if(_type === 'CREDIT NOTE'){
            //totalValueSign = "-";
          }

          // report* totals cover every page of the filter and net credit notes;
          // fall back to the page totals if the API does not send them yet.
          let _reportTotal = responseJson.reportTotalAmt !== undefined ? responseJson.reportTotalAmt : responseJson.totalTransAmt;
          let _reportBalance = responseJson.reportBalanceAmt !== undefined ? responseJson.reportBalanceAmt : responseJson.totalBalanceAmt;

          this.setState({
            transactionArrayFilter: _transArray,
            itemArray: _transArray,
            isLoaded: true,
            paidAmount: _reportTotal - _reportBalance,
            totalBalanceAmt: _reportBalance,
            total: _reportTotal,
            totalCount: responseJson.totalCount,
            totalValueSign: totalValueSign,
          });
        }
      })
      .catch((error) => this.setState({ error, isLoaded: false }));
  }

  loadTranscListing() {
    let dataList = [];
    let rows = [];
    if (this.state.isLoaded == true) {
      let _transDetails = this.state.transactionArrayFilter;
      if (_transDetails.length > 0) {
        let _i=0;
        _transDetails.map((value, index) => {
          _i++; 
          let _textShow = "Credit Note";
          let _trans_duplicate_normal = value.trans_duplicate_normal ? value.trans_duplicate_normal : '';
          if (value.type == "SALE") {
            _textShow = "Sale";
          }
          let _typeSend = "&tType=Report";
          let _editActionUrl = global.webUrl + "business/add-sale/?auth=" + value.id+_typeSend;
          let _editDuplicateActionUrl =global.webUrl + "business/add-sale/?auth=" + value.id+'&tType=DUPLICATE';
          if (value.type == "SALE") {
            _editActionUrl =global.webUrl + "business/add-sale/?auth=" + value.id+_typeSend;
            _editDuplicateActionUrl =global.webUrl + "business/add-sale/?auth=" + value.id+'&tType=DUPLICATE';
          } else if (value.type == "CREDIT NOTE") {
            _editActionUrl = global.webUrl + "business/add-sale-credit-note/?auth=" + value.id+_typeSend;
            _editDuplicateActionUrl = global.webUrl + "business/add-sale-return-duplicate/?auth="+value.id;
          }

          let _actionExtra = "";
          if (value.type == "SALE") {
            _actionExtra = (
              <div className="btn-group" role="group">
                <button
                  type="button"
                  id="btnGroupVerticalDrop3"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fa fa-ellipsis-v"></i>
                </button>
                <div
                  className="dropdown-menu"
                  aria-labelledby="btnGroupVerticalDrop1"
                >
                  
                  {_trans_duplicate_normal === 'Normal' &&
                  <a className="dropdown-item" href={_editDuplicateActionUrl}>
                    Duplicate
                  </a>
                  }
                  
                  {_trans_duplicate_normal === 'Normal' &&
                    <a className="dropdown-item" href={_editActionUrl}>
                      View/Edit Details
                    </a>
                  }
                  
                  {_trans_duplicate_normal === 'Normal' &&
                    <a
                      className="dropdown-item"
                      href={
                        global.webUrl +
                        "business/add-receive-payment-in/?auth=" +
                        value.id+_typeSend
                      }
                    >
                      Receive Payment
                    </a>
                  }
                  
                  {/* canCreateReturn is false once every line is fully returned */}
                  {_trans_duplicate_normal === 'Normal' && value.canCreateReturn !== false &&
                    <a
                      className="dropdown-item"
                      href={
                        global.webUrl +'business/add-sale-credit-note?auth='+value.id+"&tType=CREDIT NOTE&isConvert=true"
                      }
                    >
                      Convert to Return
                    </a>
                  }
                  <a
                    className="dropdown-item"
                    href="javascript:void(0)"
                    data-id={value.id}
                    onClick={this.clickToDelete.bind(this, value.id, "Sale")}
                  >
                    Delete
                  </a>
                  <a
                    className="dropdown-item"
                    href={
                      global.webUrl + "business/challanPdfDialog/?auth=" + value.id
                    }
                    target="_blank"
                  >
                    Preview as Delivery Challan
                  </a>
                  <DownloadBtnSaleInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                  <Link className="dropdown-item" to={'/business/salePdfDialog/?auth='+value.id} target="_blank">
                      Preview
                  </Link>
                  <PrintBtnSaleInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                  {/* <ButtonPdf transactionId={value.id} isChallanPreview={true}/> */}
                </div>
              </div>
            );
          } else if (value.type == "CREDIT NOTE") {
            _actionExtra = (
              <div className="btn-group" role="group">
                <button
                  type="button"
                  id="btnGroupVerticalDrop3"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fa fa-ellipsis-v"></i>
                </button>
                <div
                  className="dropdown-menu"
                  aria-labelledby="btnGroupVerticalDrop1"
                >
                  
                  {_trans_duplicate_normal === 'Normal' &&
                    <a className="dropdown-item" href={_editActionUrl}>
                      View/Edit Details
                    </a>
                  }
                  <a
                    className="dropdown-item"
                    href="javascript:void(0)"
                    data-id={value.id}
                    onClick={this.clickToDelete.bind(this,value.id,"CREDIT NOTE")}
                  >
                    Delete
                  </a>
                  {_trans_duplicate_normal === 'Normal' &&
                    <a className="dropdown-item" href={_editDuplicateActionUrl}>
                      Duplicate
                    </a>
                  }
                  {_trans_duplicate_normal === 'Normal' &&
                    <a
                      className="dropdown-item"
                      href={
                        global.webUrl +
                        "business/add-make-payment-out/?auth=" +
                        value.id+_typeSend
                      }
                    >
                      Make Payment
                    </a>
                  }
                  <DownloadBtnSaleReturnInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                  <Link className="dropdown-item" to={'/business/saleReturnPdfDialog/?auth='+value.id} target="_blank">
                      Preview
                  </Link>
                  <PrintBtnSaleReturnInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                  {/* <ButtonPdf transactionId={value.id} isChallanPreview={true}/> */}
                </div>
              </div>
            );
          } else {
            _actionExtra = (
              <div className="btn-group" role="group">
                <button
                  type="button"
                  id="btnGroupVerticalDrop3"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fa fa-ellipsis-v"></i>
                </button>
                <div
                  className="dropdown-menu"
                  aria-labelledby="btnGroupVerticalDrop1"
                >
                  {_trans_duplicate_normal === 'Normal' &&
                  <a className="dropdown-item" href={_editDuplicateActionUrl}>
                    Duplicate
                  </a>
                  }
                  {_trans_duplicate_normal === 'Normal' &&
                  <a
                    className="dropdown-item"
                    href={
                      global.webUrl +
                      "business/add-make-payment-out/?auth=" +
                      value.id+_typeSend
                    }
                  >
                    Make Payment
                  </a>
                  }
                  <DownloadBtnSaleReturnInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                  <Link className="dropdown-item" to={'/business/saleReturnPdfDialog/?auth='+value.id} target="_blank">
                      Preview
                  </Link>
                  <PrintBtnSaleReturnInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                  {/* <ButtonPdf transactionId={value.id}/> */}
                </div>
              </div>
            );
          }


          let _saleType = <span className="badge badge-warning">UNPAID</span>;
          if(value.payment_paid == 'PARTIAL'){
              _saleType = <span className="badge badge-info">{value.payment_paid}</span>;
          }
          else if(value.payment_paid == 'PAID'){
              _saleType = <span className="badge badge-success">{value.payment_paid}</span>;
          }
          let _pageAK = this.state.setPage;
          
          let _showDupL = '';
          if(_trans_duplicate_normal == 'Duplicate'){
              _showDupL = ' (Duplicate)';
          }
          
          if(this.state.DueDatesPaymentTerms == 1){
            let _dueDates =  value.payment_term_due_date;
            if(value.payment_term_due_date == '0' || value.payment_term_due_date == '' || value.payment_term_due_date == ''){
              _dueDates = 'NA'
            }
            if(value.payment_term_due_status.length > 3 && value.balance >0){
              _saleType = <span className="badge badge-danger">Overdue</span>;
            }
            rows.push({
              srNo: ((_pageAK - 1) * this.state.pageCount) + _i,
              invoice_date: (value.type === 'CREDIT NOTE' ? value.invoice_date_return : value.invoice_date),
              invoice_no: value.invoice_no + _showDupL, //value.customPrefix+' #'+value.invoice_no,
              party_name: value.party_name,
              sale_type: _textShow,
              payment_type: value.payment_type,
              total_amount: numberFormat(value.total_amount),
              balance: numberFormat(value.balance),
              status: _saleType,
              due_date: _dueDates,
              actionExtra: _actionExtra,
            });
          }
          if(this.state.DueDatesPaymentTerms == 0){
            rows.push({
              srNo: ((_pageAK - 1) * this.state.pageCount) + _i,
              invoice_date: (value.type === 'CREDIT NOTE' ? value.invoice_date_return : value.invoice_date),
              invoice_no: value.invoice_no + _showDupL, //value.customPrefix+' #'+value.invoice_no,
              party_name: value.party_name,
              sale_type: _textShow,
              payment_type: value.payment_type,
              total_amount: numberFormat(value.total_amount),
              balance: numberFormat(value.balance),
              status: _saleType,
              actionExtra: _actionExtra,
            });
          }
        });
      }
    }

    if (rows) {
      dataList = {
        columns: columns,
        rows: rows,
      };
    }
    return dataList;
  }

  handleCallBackDate = (start, end) => {
    /*this.setState({
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    });
    this.getSaleListData();*/
    
    // A new filter starts again from page 1 (setPage drives the pagination and
    // row numbering) and keeps the current search text and rows per page.
    this.setState({startDate:start.format('YYYY-MM-DD'),endDate:end.format('YYYY-MM-DD'),setPage:1}, () => {
      this.getSaleListData(this.state.activeTransactionKey,this.state.activeTransactionPaymentKey,1,this.state.activePartyKey,this.state.searchInvNo,this.state.pageCount);
    });
  };

  clickToDelete(value, type) {
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          label: "Yes",
          className: "btn btn-danger",
          onClick: () => {
            const requestData = JSON.stringify({
              sale_id: value,
              type_value: type,
            });
            PostData(global.deleteSaleTransaction, requestData, "POST").then(
              (result) => {
                let responseJson = result;
                if (responseJson.success == false) {
                  sendNotification(
                    "Error Message 😓",
                    responseJson.message,
                    "danger"
                  );
                  return;
                } else {
                  sendNotification(
                    "Success Message 👍",
                    responseJson.message,
                    "success"
                  );
                  //this.getSaleListData();
                  this.setState({setPage:1});
                  this.getSaleListData(this.state.activeTransactionKey,this.state.activeTransactionPaymentKey,1,this.state.activePartyKey,this.state.searchInvNo,this.state.pageCount);
                  return;
                }
              }
            );
          },
        },
        {
          label: "No",
          className: "btn btn-dark",
        },
      ],
    });
  }

  exportData = (event) =>{
    let _itemDetails = this.state.itemArray;
    try {
      let totalAmount = 0;
      _itemDetails.map((data) => {
        totalAmount += parseFloat(data.total_amount);
      });

      _itemDetails = _itemDetails.map((data) => {

        let newData = {
          'Date': data.invoice_date,
          'Order No': data.order_number,
          'Invoice No': data.invoice_no,
          'Party Name': data.party_name,
          'Party Phone No.': data.party_phone,
          'Transaction Type': data.type,
          'Total Amount': data.total_amount,
          'Payment Type': data.payment_type,
          'Received/Paid Amount': data.received_amount,
          'Balance Due': data.balance,
          'Payment Status': data.payment_paid,
          'Description': data.description,
          'Transport Name': data.TransportDetailField1,
          'Vehicle Number': data.TransportDetailField2,
        }
         return newData;
      });

      let totalAmountRow = {
        'Date': '',
        'Order No': '',
        'Invoice No': '',
        'Party Name': '',
        'Party Phone No.': '',
        'Transaction Type': 'Total',
        'Total Amount': totalAmount,
        'Payment Type': '',
        'Received/Paid Amount': '',
        'Balance Due': '',
        'Payment Status': '',
        'Description': '',
        'Transport Name': '',
        'Vehicle Number': '',
      };

      _itemDetails.push({});
      _itemDetails.push(totalAmountRow);
      var ws = XLSX.utils.json_to_sheet(_itemDetails);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb,ws,"Sale Report");
      const wbout = XLSX.write(wb, {type:'array', bookType:"xlsx"});
      let length = 6;
      let uniqueNo = String(Math.floor(Math.pow(10, length - 1) + Math.random() * (Math.pow(10, length) - Math.pow(10, length - 1) - 1)));
      let fileName = 'export_sale_'+moment().format('YYYY-MM-DD')+'.xlsx';
      const data = new Blob([wbout], {type: "xlsx"});
      FileSaver.saveAs(data, fileName);

    } catch (err) {
      //alert('Unknown Error: ' + JSON.stringify(err));
      throw err;
    }
  }

  changeTypeFilter = (e) => {
      this.setState({activeTransactionKey : e.target.value, setPage : 1});
      this.getSaleListData(e.target.value,this.state.activeTransactionPaymentKey,1,this.state.activePartyKey,this.state.searchInvNo,this.state.pageCount);
  }
  changeTypePayStausFilter = (e) => {
      this.setState({activeTransactionPaymentKey : e.target.value, setPage : 1});
      this.getSaleListData(this.state.activeTransactionKey,e.target.value,1,this.state.activePartyKey,this.state.searchInvNo,this.state.pageCount);
  }

  changePartyFilter = (e) => {
    this.setState({activePartyKey : e.target.value, setPage : 1});
    this.getSaleListData(this.state.activeTransactionKey,this.state.activeTransactionPaymentKey,1,e.target.value,this.state.searchInvNo,this.state.pageCount);
  }
  render() {
    if (this.state.isLoaded == true) {
      _loader = "glb-ldr-prt";
    }
    const { errors } = this.state;
    return (
      <React.Fragment>
        <div className="content">
          <div className="block">
            <div className="row">
              <div className="col-md-12">
                <h5># Sale Report</h5>
                <div className="block">
                  <div className="block-content" style={{ marginTop: "-20px" }}>
                    <div className="row items-push">
                      <div className="row col-lg-12">
                        <div className="col-lg-10">
                          <span>Filter : </span>
                          <DateRangePicker
                            initialSettings={{
                              startDate: this.state.startDate,
                              endDate: this.state.endDate,
                              locale: {
                                format: "YYYY-MM-DD",
                              },
                              ranges: {
                                Today: [moment().toDate(), moment().toDate()],
                                Yesterday: [
                                  moment().subtract(1, "days").toDate(),
                                  moment().subtract(1, "days").toDate(),
                                ],
                                "This Week": [
                                  moment()
                                    .startOf("week")
                                    .format("YYYY-MM-DD"),
                                  moment().endOf("week").format("YYYY-MM-DD"),
                                ],
                                "This Month": [
                                  moment().startOf("month").toDate(),
                                  moment().endOf("month").toDate(),
                                ],
                                "Last Month": [
                                  moment()
                                    .subtract(1, "month")
                                    .startOf("month")
                                    .toDate(),
                                  moment()
                                    .subtract(1, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Quarter": [
                                  moment().startOf("month").toDate(),
                                  moment()
                                    .add(2, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Financial Year": [
                                  moment()
                                    .month("April")
                                    .startOf("month")
                                    .format("YYYY-MM-DD"),
                                  moment()
                                    .add(1, "year")
                                    .month("March")
                                    .endOf("month")
                                    .format("YYYY-MM-DD"),
                                ],
                              },
                            }}
                            onCallback={this.handleCallBackDate}
                          >
                            <input
                              type="text"
                              className="form-control col-4"
                              style={{ display: "inline-block" }}
                            />
                          </DateRangePicker>
                          <select onChange={this.changeTypeFilter} className="form-control col-2" style={{display: 'inline-block',marginLeft: '4px'}}>
                              <option value="ALL">All Transaction</option>
                              <option value="SALE">Sale</option>
                              <option value="CREDIT NOTE">Credit Note</option>
                          </select>
                          <select onChange={this.changeTypePayStausFilter} className="form-control col-2" style={{display: 'inline-block',marginLeft: '4px'}}>
                              <option value="ALL">All Status</option>
                              <option value="Paid">Paid</option>
                              <option value="Partial">Partial</option>
                              <option value="Unpaid">Unpaid</option>
                          </select>
                          <select onChange={this.changePartyFilter} className="form-control col-3" style={{display: 'inline-block',marginLeft: '4px'}}>
                              <option value="ALL">All Party</option>
                              {this.state.partyData.map((item, index) => {
                                  let _sel = "";
                                  if (this.state.activePartyKey == item.party_id) {
                                  _sel = "selected";
                                  }
                                  return (
                                  <option
                                      key={index}
                                      value={item.party_id}
                                      selected={_sel}
                                  >
                                      {item.party_name}
                                  </option>
                                  );
                              })}
                          </select>
                          
                        </div>
                        <div className="col-lg-2">
                          <div className="row pb-20 pull-right">
                            <div className="text-right">
                              <div className="js-appear-enabled text-center">
                                <Link onClick={this.exportData} >
                                  <div className="text-info">
                                    <i className="fa fa-file-excel-o"></i>
                                  </div>
                                  <div className="font-size-sm text-muted">
                                        Excel Export
                                  </div>
                                </Link>
                              </div>
                            </div>
                            {/* <div className="col-6 text-right border-r">
                                <div className="js-appear-enabled text-center">
                                    <div className="text-info"><i className="fa fa-file-excel-o"></i></div>
                                    <div className="font-size-sm text-muted">Excel Export</div>
                                </div>
                            </div> */}
                            {/* <div className="col-6">
                                <div className="js-appear-enabled text-center">
                                    <div className="text-success"><i className="fa fa-print"></i></div>
                                    <div className="font-size-sm text-muted">Print</div>
                                </div>
                            </div> */}
                          </div>
                        </div>
                        <br />
                      </div>
                      <div className="col-lg-12">
                        {/* <div className="blockAreaList">
                          <div className="py-10 text-left" id="paidArea">
                            <div className="text-muted">Paid</div>
                            <div className="font-size-h5 font-w600">
                              {numberFormat(this.state.paidAmount)}
                            </div>
                          </div>
                        </div>
                        <div className="blockAreaListIcon">
                          <i className="fa fa-plus"></i>
                        </div> */} 
                        <div className="blockAreaList">
                          {this.state.totalValueSign === '' &&
                          <div className="py-10 text-left" id="unpaidArea">
                            <div className="text-muted">Balance Due</div>
                            <div className="font-size-h5 font-w600">
                              {numberFormat(this.state.totalBalanceAmt)}
                            </div>
                          </div>
                          }
                          
                          {this.state.totalValueSign != '' &&
                          <div className="py-10 text-left" id="unpaidAreaRed">
                            <div className="text-muted">Balance Due</div>
                            <div className="font-size-h5 font-w600">
                              {numberFormat(this.state.totalBalanceAmt)}
                            </div>
                          </div>
                          }
                        </div>
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        {/* <div className="blockAreaListIcon">
                          <i className="fas fa-equals"></i>
                        </div> */}
                        <div className="blockAreaList">
                          <div className="py-10 text-left" id="totalArea">
                            <div className="text-muted">Total</div>
                            <div className="font-size-h5 font-w600">
                              {this.state.totalValueSign} {numberFormat(this.state.total)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="block" style={{ marginTop: "-60px" }}>
            <div className="row">
              <div className="col-md-12">
                <div className="block">
                  <div className="block-content">
                      <h2 className="block-title ml-10">Transactions</h2>
                      <input type="text" className="form-control col-6" style={{display:'inline-block'}} placeholder='search invoice number (type at least three characters)'onChange={this.getInvoiceSearch}/>
                      <Link to={"/business/add-sale/"} style={{}} className="pull-right btn btn-sm btn-primary">
                          <i className="fa fa-plus-circle"></i> Add Sale
                      </Link>
                  </div>
                  <div className="block-content" id="tableData"style={{margin:'10px'}} >
                      <MDBDataTableV5
                          hover
                          span
                          displayEntries={false}
                          entries={100}
                          pagingTop={false}
                          searchTop={false}
                          searchBottom={false}
                          info={false}
                          barReverse
                          data={this.loadTranscListing()}
                      />
                  </div>
                  <div style={{ float: "right", marginTop: "-15px" }}>
                      <div className="d-flex align-items-center justify-content-end">
                          <div className="d-flex align-items-center">
                          <div role="status" aria-live="polite"> Rows per page:</div>
                          </div>
                          <div className="d-flex align-items-center" >
                          <select className=" d-flex align-items-center custom-select custom-select-sm form-control form-control-sm"
                                  onChange={(event) => {
                                      event.preventDefault();
                                      const { name, value } = event.target;
                                      //this.setState({ pageCount: value, setPage: 1 });
                                      this.setState(prevState => ({
                                              pageCount : value,
                                              setPage : 1,
                                          }),
                                          () => {
                                              this.getSaleListData(this.state.activeTransactionKey,this.state.activeTransactionPaymentKey,1,this.state.activePartyKey,this.state.searchInvNo,value
                          
                                              );
                                          });
                                  }}>
                              <option value="10">10</option>
                              <option value="20">20</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                          </select>
                          </div>
                          <div className="d-flex align-items-center">
                          <div role="status" aria-live="polite"> Total: {this.state.totalCount}</div>
                          </div>
                      </div>
                  </div>
                  <div className="block-content">
                      <div style={{ float: "left", marginTop: "-45px" }}>
                      <PaginationControl
                          between={this.state.pageCount}
                          total={this.state.totalCount}
                          limit={this.state.pageCount}
                          changePage={(page) => {
                          this.setState({ setPage: page });
                          this.getSaleListData(this.state.activeTransactionKey,this.state.activeTransactionPaymentKey,page,this.state.activePartyKey,this.state.searchInvNo,this.state.pageCount
                          );
                          }}
                          ellipsis={1}
                          activeClass={this.state.setPage}
                          page={this.state.setPage}
                      />
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="global_loader" className={_loader}>
          <div className="gl-ldr-cld">
            <div className="gl-ldr-ctr">
              <div className="gl-loader"></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
